import React, { useEffect, useState } from 'react';
import { useBreakpoint } from '@app/lib/hooks/use-breakpoint';
import SwiperLayout from '@anonymizePro/components/feature/SwiperLayout';
import FeatureMain from '@anonymizePro/components/feature/featureMain';

function Index() {
    const screenSize = useBreakpoint();

    const [domLoaded, setDomLoaded] = useState(false);

    useEffect(() => {
        setDomLoaded(true);
    }, []);

    if (domLoaded) {
        if (screenSize === 'xs' || screenSize === 'sm' || screenSize === '2xs' || screenSize === 'md') {
            return <SwiperLayout />;
        } else {
            return <FeatureMain />;
        }
    }

    return <></>;
}

export default Index;
